module.exports = __webpack_public_path__ + "img/alex_assessment.5eac9aa1.svg";